import "./LandingPage.scss";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import AnnexIconHero from '../../assets/images/landing-pages/annex-icon-hero.png';
import MetaDecorator from "../../MetaDecorator";

// On-brand phrases the hero cycles through, echoing the site's existing copy.
const HERO_PHRASES = [
  "Artists Living Comfortably",
  "Live, Don't Sleep",
  "Live Like a Local",
  "A New Kind of Hotel",
];

const PHRASE_INTERVAL_MS = 4000;

export default function LandingPage() {
  const [phraseIndex, setPhraseIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setPhraseIndex((prev) => (prev + 1) % HERO_PHRASES.length);
    }, PHRASE_INTERVAL_MS);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="landing-container">
      <MetaDecorator
        title="Discover the Annex"
        description="A New Kind of Hotel - Enjoy the comforts that make a house a home. Come live like a local."
      />
      <div className="landing-hero">
        <video
          className="landing-hero__video"
          src={`${process.env.PUBLIC_URL}/annex-hero.mp4`}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        />
        <div className="landing-hero__mask"></div>
        {/* <img src={AnnexIconHero} alt="Annex Icon Hero" className="landing-hero__icon" loading="lazy"/>     */}
        {/* key forces a re-mount each phrase so the fade-in animation replays */}
        <h1 key={phraseIndex} className="landing-hero__cursive">
          {HERO_PHRASES[phraseIndex]}
        </h1>
      </div>
      <div className="experience">
        <Link to="/experience" className="experience__button">
          Experience
        </Link>
        <div className="experience__image">
          <div className="experience-image-mask"></div>
          {/* <img src={AnnexIconHero} alt="Annex Icon Hero" className="landing-hero__icon" loading="lazy" /> */}
          <div className="experience-title">
            <h1 className="experience-title__text-1">Live,</h1>
            <h1 className="experience-title__text-2">don't sleep</h1>
          </div>
        </div>
      </div>
      <div className="experience-live-local-divider mobile-only"></div>
      <div className="live-local">
        <Link to="/live-local" className="live-local__button">
          Stay
        </Link>
        <div className="live-local__image">
          <div className="live-local-image-mask"></div>
          {/* <img src={AnnexIconHero} alt="Annex Icon Hero" className="landing-hero__icon icon-enhance" loading="lazy"/> */}
          <div className="live-local-title">
            <h1 className="live-local-title--1">Live like</h1>
            <h1 className="live-local-title--2">a local</h1>
          </div>
        </div>
      </div>
    </div>
  );
}
